// extracted by mini-css-extract-plugin
export default {"sideLeft":"Home_sideLeft__dFMGk","sideRight":"Home_sideRight__uhB9Q","page":"Home_page__3iciG","tabletEvents":"Home_tabletEvents__n579y"};